import { Link } from "react-router-dom";
import { FaFolderOpen } from "react-icons/fa";

const EmptyState = ({
  icon: Icon = FaFolderOpen,
  title = "No records found yet.",
  description = "Your medical history will appear here. Upload past lab results, doctor's notes, or imaging files to keep everything in one secure place.",
  actionLabel,
  actionTo,
  onAction,
  className = "",
}) => (
  <div
    className={`bg-surface-lowest border border-surface-container rounded-2xl py-12 px-6 text-center max-w-lg mx-auto ${className}`}
  >
    <div className="w-16 h-16 rounded-full bg-surface-low flex items-center justify-center mx-auto mb-5">
      <Icon className="text-primary text-2xl" />
    </div>
    <h3 className="text-lg font-bold text-on-primary-fixed-var mb-2">{title}</h3>
    <p className="text-sm text-on-surface-variant mb-6 max-w-sm mx-auto leading-relaxed">{description}</p>
    {(actionLabel && actionTo) && (
      <Link
        to={actionTo}
        className="inline-flex items-center justify-center gap-2 bg-primary text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:bg-primary-container transition-colors"
      >
        {actionLabel}
      </Link>
    )}
    {(actionLabel && onAction && !actionTo) && (
      <button
        type="button"
        onClick={onAction}
        className="inline-flex items-center justify-center gap-2 bg-primary text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:bg-primary-container transition-colors"
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
